import * as React from "react"
import Layout from "../components/Layout/Layout"
import Title from "../components/Title/Title"
import BreadcrumbBar from "../components/BreadcrumbBar/BreadcrumbBar"

function Privacy() {
    const parentPages = [{name: "Home", path: "/"}]

    return (
        <Layout>
            <Title title="Privacy Policy" />
            <BreadcrumbBar currentPage="Privacy Policy" parentPages={parentPages} />
            <section style={{width: 'min(90%, 1000px)', margin: 'auto'}}>
                <p>Esse ad nulla consectetur anim incididunt sit excepteur ad est pariatur pariatur consequat. Eiusmod eiusmod incididunt ex excepteur non in officia. Laborum ea voluptate qui consectetur enim. Laboris est ut elit mollit adipisicing velit. Est culpa est enim culpa magna esse. Culpa dolor aute laboris eiusmod et qui ea adipisicing ipsum ea. Quis labore ex eu laboris sit qui enim nostrud aliqua dolor voluptate nulla nulla Lorem.</p>
                <p>Et consequat id cillum esse in aliquip esse. Commodo consequat sint in cillum ipsum quis ullamco cillum ullamco id dolor commodo minim ipsum. Ea magna est amet commodo irure consequat ipsum. Dolore et commodo quis dolore. Dolore incididunt eiusmod occaecat nostrud consectetur ut magna est tempor dolore elit mollit dolor fugiat. Velit amet enim fugiat amet aliquip veniam.</p>
            </section>
        </Layout>
    )
}

export default Privacy